import dayjs from 'dayjs';

const getImgSrc = (src: string) => {
  if (process.env.REACT_APP_CURRENT_CONFIG === 'production') {
    return `${process.env.REACT_APP_BASE_URL}/media${src.split('/media')[1]}`;
  }
  return src;
};

export const allTimeSlots = [
  { value: '8-10', label: '৮-১০' },
  { value: '10-12', label: '৮-১২' },
  { value: '12-2', label: '৮-২' },
  { value: '2-4', label: '৮-সর্বশেষ' },
];

export const timeSlotMappers = (slot: string): string => {
  const findSlot = allTimeSlots.find((item) => item.value === slot);
  return findSlot?.label || '';
};

export const autoSlotSelector = (): {
  showSlotRange: string;
  sendSlotRange: string;
} => {
  const currentHour = Number(dayjs().format('HH'));

  let showSlotRange = '';
  let sendSlotRange = '';

  if (currentHour < 12) {
    showSlotRange = '8-10';
    sendSlotRange = '8-10';
  } else if (currentHour >= 12 && currentHour < 14) {
    showSlotRange = '10-12';
    sendSlotRange = '10-12';
  } else if (currentHour >= 14 && currentHour < 16) {
    showSlotRange = '12-2';
    sendSlotRange = '12-2';
  } else {
    showSlotRange = '2-4';
    sendSlotRange = '2-4';
  }

  return {
    showSlotRange,
    sendSlotRange,
  };
};

export const divisionMapper = (
  divisionList:
    | {
        division: string;
        id: number | string;
        division_en?: string;
      }[]
    | [],
): {
  value: number | string;
  label: string;
}[] => {
  const divisionOptions = divisionList?.map((item: any) => ({
    value: `${item?.id}`,
    label: item?.division,
  }));

  return divisionOptions || [];
};

export const numberLanguageFormatter = (
  item: number | string,
  type: string = 'en',
): string => {
  let modifiedItem = '';

  const englishNumber = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
  const bengaliNumber = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯', '.'];

  const getItem = `${item}`;

  const currentNumber = type === 'en' ? englishNumber : bengaliNumber;
  const targetNumber = type === 'en' ? bengaliNumber : englishNumber;

  for (let i = 0; i < getItem.trim().length; i++) {
    const findIndex = currentNumber.findIndex(
      (item) => item === getItem[`${i}`],
    );

    modifiedItem = `${modifiedItem}${
      targetNumber[findIndex] ? targetNumber[findIndex] : ''
    }`;
  }

  return modifiedItem;
};

export { getImgSrc };
